(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('image-marquee')) {
    class ImageMarquee extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.group = this.querySelector('[data-group]');
        if (!this.track || !this.group) return;

        this.desktopQuery = window.matchMedia('(min-width: 750px)');
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.frame = null;
        this.onChange = () => this.schedule();

        this.desktopQuery.addEventListener('change', this.onChange);
        this.motionQuery.addEventListener('change', this.onChange);

        this.observer = new ResizeObserver(this.onChange);
        this.observer.observe(this);
        this.observer.observe(this.group);

        this.schedule();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.desktopQuery) this.desktopQuery.removeEventListener('change', this.onChange);
        if (this.motionQuery) this.motionQuery.removeEventListener('change', this.onChange);
        cancelAnimationFrame(this.frame);
      }

      schedule() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.build());
      }

      build() {
        this.track.querySelectorAll('[data-clone]').forEach((el) => el.remove());

        if (this.motionQuery.matches) {
          this.classList.remove('is-ready');
          this.classList.add('is-static');
          return;
        }
        this.classList.remove('is-static');

        const groupWidth = this.group.getBoundingClientRect().width;
        if (!groupWidth) return;

        const copies = Math.ceil(this.clientWidth / groupWidth) + 1;
        for (let i = 0; i < copies; i++) {
          const clone = this.group.cloneNode(true);
          clone.removeAttribute('data-group');
          clone.setAttribute('data-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));
          this.track.appendChild(clone);
        }

        const speed = Number(this.desktopQuery.matches ? this.dataset.speedDesktop : this.dataset.speedMobile) || 50;
        this.track.style.setProperty('--imq-shift', groupWidth + 'px');
        this.track.style.setProperty('--imq-duration', (groupWidth / Math.max(speed, 1)) + 's');
        this.classList.add('is-ready');
      }
    }
    customElements.define('image-marquee', ImageMarquee);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-profile-embed"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('instagram-profile-embed')) {
    const EMBED_SCRIPT = 'https://www.instagram.com/embed.js';

    const loadEmbedScript = () => {
      if (window.__igEmbedPromise) return window.__igEmbedPromise;
      window.__igEmbedPromise = new Promise((resolve, reject) => {
        if (window.instgrm && window.instgrm.Embeds) { resolve(); return; }
        const script = document.createElement('script');
        script.async = true;
        script.src = EMBED_SCRIPT;
        script.onload = () => resolve();
        script.onerror = () => { window.__igEmbedPromise = null; reject(new Error('Instagram embed script blocked')); };
        document.head.appendChild(script);
      });
      return window.__igEmbedPromise;
    };

    class InstagramProfileEmbed extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-viewport]');
        this.loading = this.querySelector('[data-loading]');
        this.mounted = false;
        this.setupReveal();
        this.setupLazyMount();
      }

      disconnectedCallback() {
        if (this.revealObserver) this.revealObserver.disconnect();
        if (this.mountObserver) this.mountObserver.disconnect();
        clearTimeout(this.slowTimer);
        clearInterval(this.pollTimer);
      }

      /* Scroll reveal */
      setupReveal() {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const inEditor = window.Shopify && window.Shopify.designMode;
        if (this.dataset.reveal !== 'true' || reduce || inEditor || !('IntersectionObserver' in window)) {
          this.classList.add('is-inview');
          return;
        }
        this.classList.add('is-armed');
        this.revealObserver = new IntersectionObserver((entries) => {
          if (entries.some((e) => e.isIntersecting)) {
            this.classList.add('is-inview');
            this.revealObserver.disconnect();
          }
        }, { threshold: 0.05, rootMargin: '0px 0px -8% 0px' });
        this.revealObserver.observe(this);
      }

      /* Load Instagram only when the section is near the screen (faster page) */
      setupLazyMount() {
        const inEditor = window.Shopify && window.Shopify.designMode;
        if (inEditor || !('IntersectionObserver' in window)) {
          this.mount();
          return;
        }
        this.mountObserver = new IntersectionObserver((entries) => {
          if (entries.some((e) => e.isIntersecting)) {
            this.mountObserver.disconnect();
            this.mount();
          }
        }, { rootMargin: '400px 0px' });
        this.mountObserver.observe(this);
      }

      mount() {
        if (this.mounted || !this.viewport) return;
        this.mounted = true;
        this.slowTimer = setTimeout(() => this.classList.add('is-slow'), 12000);
        if (this.dataset.method === 'iframe') {
          this.mountIframe();
        } else {
          this.mountScript();
        }
      }

      safeInstagramUrl(u) {
        return typeof u === 'string' && /^https:\/\/www\.instagram\.com\//.test(u);
      }

      markReady() {
        clearTimeout(this.slowTimer);
        clearInterval(this.pollTimer);
        this.classList.add('is-ready');
        if (this.loading) this.loading.hidden = true;
      }

      /* Method 1: Instagram profile page in an iframe */
      mountIframe() {
        const url = this.dataset.embedUrl;
        if (!this.safeInstagramUrl(url)) return;
        const iframe = document.createElement('iframe');
        iframe.className = 'ipe__iframe';
        iframe.src = url;
        iframe.title = 'Instagram profile @' + (this.dataset.username || '');
        iframe.setAttribute('allowtransparency', 'true');
        iframe.setAttribute('scrolling', 'yes');
        iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
        iframe.addEventListener('load', () => this.markReady());
        this.viewport.appendChild(iframe);
      }

      /* Method 2: Instagram's official embed script */
      mountScript() {
        const permalink = this.dataset.permalink;
        if (!this.safeInstagramUrl(permalink)) return;

        const quote = document.createElement('blockquote');
        quote.className = 'instagram-media';
        quote.setAttribute('data-instgrm-permalink', permalink);
        quote.setAttribute('data-instgrm-version', '14');
        quote.style.cssText = 'background:#FFF;border:0;border-radius:3px;margin:0;max-width:540px;min-width:326px;padding:0;width:100%;';

        const link = document.createElement('a');
        link.href = this.dataset.profileUrl;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.textContent = 'View this profile on Instagram';
        quote.appendChild(link);
        this.viewport.appendChild(quote);

        loadEmbedScript()
          .then(() => {
            if (window.instgrm && window.instgrm.Embeds) window.instgrm.Embeds.process();
            let tries = 0;
            this.pollTimer = setInterval(() => {
              tries += 1;
              if (this.viewport.querySelector('iframe.instagram-media-rendered, iframe')) {
                this.markReady();
              } else if (tries > 40) {
                clearInterval(this.pollTimer);
              }
            }, 300);
          })
          .catch(() => {
            this.classList.add('is-slow');
          });
      }
    }
    customElements.define('instagram-profile-embed', InstagramProfileEmbed);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initThumbs = (root) => {
      (root || document).querySelectorAll('[data-pl-thumbs]:not([data-pl-ready])').forEach((strip) => {
        strip.setAttribute('data-pl-ready', 'true');

        const item = strip.closest('.resource-list__item');
        if (!item) return;

        const selector = strip.dataset.gallerySelector || '.card-gallery';
        let gallery = null;
        try {
          gallery = item.querySelector(selector);
        } catch (e) {
          gallery = null;
        }
        if (!gallery) return;

        // Move the strip directly under the main image (outside any wrapping link).
        const link = gallery.closest('a');
        const anchor = link && item.contains(link) ? link : gallery;
        anchor.insertAdjacentElement('afterend', strip);

        const img = gallery.querySelector('img');
        if (!img) return;
        img.setAttribute('data-pl-main', '');

        const buttons = Array.from(strip.querySelectorAll('.pl-thumb'));
        const first = buttons[0];
        const hoverMode = strip.dataset.trigger !== 'click';
        let token = 0;

        const show = (btn) => {
          buttons.forEach((b) => {
            const on = b === btn;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
          });

          if (!btn.dataset.src) return;
          const current = ++token;
          img.setAttribute('data-pl-swapping', '');

          const pre = new Image();
          const apply = () => {
            if (current !== token) return;
            img.srcset = btn.dataset.srcset;
            img.src = btn.dataset.src;
            img.removeAttribute('data-pl-swapping');
          };
          pre.onload = apply;
          pre.onerror = apply;
          pre.srcset = btn.dataset.srcset;
          if (img.sizes) pre.sizes = img.sizes;
          pre.src = btn.dataset.src;
        };

        buttons.forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            show(btn);
          });

          if (hoverMode) {
            btn.addEventListener('pointerenter', (e) => {
              if (e.pointerType === 'mouse') show(btn);
            });
          }
        });

        if (hoverMode) {
          strip.addEventListener('pointerleave', (e) => {
            if (e.pointerType === 'mouse' && first) show(first);
          });
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initThumbs());
    } else {
      initThumbs();
    }

    document.addEventListener('shopify:section:load', (e) => initThumbs(e.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
